import React from "react";
import { motion } from "framer-motion";

const OurNetworks = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0.0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{
          delay: 0.3,
          duration: 0.8,
          ease: "easeInOut",
        }}
        className="relative flex flex-col gap-4 items-center justify-center px-4 bg-gradient-to-br from-yellow-950/50 via-transparent"
      >
        <section className="py-10 sm:py-16 lg:pt-44 ">
          <h2 className="text-2xl lg:text-3xl CustomFont text-center pb-16 font-bold text-white">
            Our Networks
          </h2>
          <div className="grid items-center grid-cols-1 lg:grid-cols-3 gap-x-12 gap-y-12">
            <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/1.png"
                className="w-20 h-20 object-cover "
              />
              <span className="text-lg font-semibold">Scan Accounting </span>
            </div>
            <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/2.png"
                className="w-20 h-20 object-cover "
              />
              <span className="text-lg font-semibold">
                Scan Global Solutions
              </span>
            </div>
            <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/3.png"
                className="w-20 h-20 object-cover "
              />
              <span className="text-lg font-semibold">Scan Global Realty</span>
            </div>
            <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/4.png"
                className="w-20 h-20 object-cover invert"
              />
              <span className="text-lg font-semibold">
                Scan Business Brokerage
              </span>
            </div>
            {/* <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/5.png"
                className="w-20 h-20 object-cover "
              />
              <span className="text-lg font-semibold">Scan Analytics</span>
            </div>
            <div className="p-4 bg-slate-700/30 flex flex-col justify-center items-center hover:bg-slate-900 hover:-translate-y-2 transition-all duration-300 shadow-md cursor-pointer">
              <img
                src="/images/OurNetwork/6.png"
                className="w-20 h-20 object-cover "
              />
              <span className="text-lg font-semibold">Scan HR Solutions</span>
            </div> */}
          </div>
        </section>
      </motion.div>
    </>
  );
};

export default OurNetworks;
